var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileArrowNe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 8,
  viewBox: "0 0 8 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.428 0a.857.857 0 1 0 0 1.714h3.645L.251 6.537a.858.858 0 0 0 1.212 1.212l4.822-4.823v3.645a.857.857 0 1 0 1.715 0V0z"
})));
export default SvgPinterestMobileArrowNe;